import { useCallback } from 'react'
import { buildRelativeLandingPageUrl } from '../../utils/UrlBuilders'
import { TextId, useTextsV2 } from '../../utils/useTexts'
import { useAppSelector } from '../../store/hooks'
import { getUrlParametersToString } from '../../utils/getUrlParametersToString'
import { getMarketLanguageState } from '../../store/appSlice'
import { getModalState } from '../../store/modalSlice'
import { TdsButton, TdsModal } from '@scania/tegel-react'

export function ModalError(): JSX.Element {
  const marketLanguage = useAppSelector(getMarketLanguageState)
  const t2 = useTextsV2()

  // Currently SC Admin only supports line breaks and we need to treat double
  // newlines as a new paragraph.
  const errorMessageParagraphs = useAppSelector(getModalState)
    .errorModalState?.split('\n\n')
    .filter((s) => s !== '')

  const handleRestartClick = useCallback(() => {
    if (!marketLanguage) {
      return
    }
    const relativeUrl = buildRelativeLandingPageUrl(marketLanguage)
    const params = relativeUrl.params
    document.location.href = relativeUrl.path + getUrlParametersToString(params)
  }, [marketLanguage])

  return (
    <TdsModal
      size="md"
      header={t2(TextId.HEADER_ERROR_NOTIFICATION)}
      show
      prevent={true}
    >
      <span slot="body">
        <div>
          {errorMessageParagraphs?.map((paragraph, i) => {
            const textRows = paragraph.split('\n')
            const rows = []
            for (let j = 0; j < textRows.length; j++) {
              const row = textRows[j]
              const rowKey = 'error-message-paragraph-' + i + '-row-' + j
              rows.push(<span key={rowKey}>{row}</span>)
              if (j < textRows.length - 1) {
                rows.push(<br key={rowKey + '-br'}></br>)
              }
            }
            return <p key={'error-message-paragraph-' + i}>{rows}</p>
          })}
        </div>
      </span>
      <span slot="actions" className="tds-u-flex tds-u-gap2 tds-u-flex-wrap">
        <TdsButton
          size="md"
          text={t2(TextId.LABEL_ACTION_RELOAD_APP)}
          onClick={handleRestartClick}
        />
      </span>
    </TdsModal>
  )
}
